import { render } from "./ModernButton.vue?vue&type=template&id=237a7eb9&scoped=true"
import script from "./ModernButton.vue?vue&type=script&lang=js"
export * from "./ModernButton.vue?vue&type=script&lang=js"

import "./ModernButton.vue?vue&type=style&index=0&id=237a7eb9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-237a7eb9"]])

export default __exports__